import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
const { PROCEDURE_15 } = environment;

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) { }

  getReportDataMinistry(idTipoPersona: number, fechaInicial, fechaFinal): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Report/GetReportData/${idTipoPersona}/${fechaInicial}/${fechaFinal}`);
  }


  getReportDataSST(idTipoPersona: number, fechaInicial, fechaFinal): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Report/GetReportDataSST/${idTipoPersona}/${fechaInicial}/${fechaFinal}`);
  }

  getFilterReport(data: any) {
    let API_URL = `${PROCEDURE_15}/Report/GetAll`;
    return this.http.post(API_URL, data);
  }

}
